export const environment = {
  production: false,
  apiBaseUrl: 'https://dev.trace0hq.com/api',
  clerkPublishableKey: 'pk_test_dG91Y2hpbmcta2l0dGVuLTczLmNsZXJrLmFjY291bnRzLmRldiQ'
};
